module.exports = __webpack_public_path__ + "img/icon2.947b5261.png";